<template>
    <v-flex>
        <v-layout row wrap style="width:70%;">
          <v-flex style="max-width:27%;" v-for="(characterEle, index) in characters" :key="index">
            <v-chip :color="characterEle.color" @click="add(characterEle.value, characterEle.color, characterEle.id)" >{{ characterEle.value }}</v-chip>
          </v-flex>
          <v-checkbox v-if="characters.length !== 0" style="margin-top:4px;" v-model="trigger" :label="`Trigger`"></v-checkbox>
        </v-layout>

        <v-card color="white">          
             <v-flex style="border:solid silver 2px;">
               <v-layout row wrap>
                <v-chip v-if="leftCharacterName" :color="leftCharacterName.characterColor" @click="removeLeft" style="height:50%">{{ leftCharacterName.characterName }}</v-chip>
                <v-chip v-else style="height:50%">{{ leftCharacterName }}</v-chip>
                <span style="margin-top:9px"> to </span>
                <v-chip v-if="rightCharacterName" :color="rightCharacterName.characterColor" @click="removeRight" style="height:50%">{{ rightCharacterName.characterName }}</v-chip>
                <v-chip v-else style="height:50%">{{ rightCharacterName }}</v-chip>     
                  <v-text-field
                    v-model="currentLine"
                    style="padding-top:0px;margin-top:0px;margin-bottom:0px;max-width:85%"              
                    label="says:"
                    single-line                  
                  ></v-text-field>                           
                    <v-btn @click="enter" absolute style="right:2px;top:10px">Enter</v-btn>                         
                </v-layout> 
            </v-flex>
            <span style="color:red" v-if="warn !== ''">{{ warn }}</span>   
        </v-card>  
    </v-flex>
</template>
<script>
import uniqid from 'uniqid'
import { db } from '../../../firebaseDB'
export default {
  props: ['timelineContent', 'editor', 'timelineId'],
  data () {
    return {
      characters: [],
      leftCharacterName: null,
      rightCharacterName: null,
      currentLine: '',
      trigger: false,
      warn: '',
      lastTextEndTime: null
    }
  },
  components: {
  },
  mounted () {
  },
  watch: {
    timelineContent () {
      if (this.timelineContent !== null) {
        this.characters = this.fetchCharacters()
        this.characters.forEach(character => {
          character.color = ('#' + (Math.random() * 0xFFFFFF << 0).toString(16))
        })
      }
      this.resumeConversation()
    }
  },
  methods: {
    fetchCharacters () {
      if (this.timelineContent.elements) {
        let charactersElements = this.timelineContent.elements.filter(ele => ele.type === 'Character')
        let user = {'id': uniqid(), 'value': 'user'}
        charactersElements.push(user)
        return charactersElements
      }
    },
    resumeConversation () {
      this.removeLeft()
      this.removeRight()
      this.trigger = false
      this.currentLine = ''
      this.lastTextEndTime = null
    },
    enter () {
      if (this.leftCharacterName && this.rightCharacterName) {
        this.$root.$emit('messageFromBottomBlock', this.currentLine, this.leftCharacterName, this.rightCharacterName, this.trigger)
        this.saveMessageToTimelineCollection(this.currentLine)
        this.warn = ''
        this.leftCharacterName = null
        this.rightCharacterName = null
        this.currentLine = ''
      } else {
        this.warn = 'Please select characters'
      }
    },
    saveMessageToTimelineCollection (currentLine) {
      let characterToBeSaved = this.characters.find(character => character.id === this.leftCharacterName.id)
      if (characterToBeSaved.elements[1].line.text === 'Enter Voice Text') {
        characterToBeSaved.elements[1].line.text = currentLine
        if (this.lastTextEndTime && characterToBeSaved.startTime < this.lastTextEndTime) {
          characterToBeSaved.elements[1].line.startTime = this.lastTextEndTime + 0.25
          characterToBeSaved.elements[1].line.endTime = characterToBeSaved.elements[1].line.startTime + (currentLine.length * 0.06361) + 1
          this.lastTextEndTime = Math.max(this.lastTextEndTime, characterToBeSaved.elements[1].line.endTime)
        } else if (this.lastTextEndTime) {
          this.lastTextEndTime = Math.max(this.lastTextEndTime, characterToBeSaved.elements[1].line.endTime)
        } else {
          this.lastTextEndTime = characterToBeSaved.elements[1].line.endTime
        }
      } else {
        let startTimeForNextText
        if (this.lastTextEndTime) {
          if (this.lastTextEndTime < characterToBeSaved.elements[characterToBeSaved.elements.length - 1].line.endTime) {
            startTimeForNextText = characterToBeSaved.elements[characterToBeSaved.elements.length - 1].line.endTime + 0.25
          } else {
            startTimeForNextText = this.lastTextEndTime + 0.25
          }
        } else {
          startTimeForNextText = characterToBeSaved.elements[characterToBeSaved.elements.length - 1].line.endTime + 0.25
        }
        let endTime = startTimeForNextText + (currentLine.length * 0.06361) + 1
        if (this.lastTextEndTime) {
          this.lastTextEndTime = Math.max(this.lastTextEndTime, endTime)
        } else {
          this.lastTextEndTime = endTime
        }
        let elementToAdd = {
          id: uniqid(),
          line: {
            type: 'Specific',
            text: currentLine,
            startTime: startTimeForNextText,
            endTime: endTime,
            voiceName: 'en-US-Standard-C.mp3',
            voiceEffect: 'None',
            voiceVolume: 1
          }
        }
        characterToBeSaved.elements.push(elementToAdd)
      }
      db.ref(`timelines/${this.timelineId}`).update(this.timelineContent).then(() => console.log('saved timeline'))
    },
    add (name, color, id) {
      if (this.leftCharacterName === null) {
        this.leftCharacterName = {characterName: name, characterColor: color, id: id}
      } else {
        this.rightCharacterName = {characterName: name, characterColor: color, id: id}
      }
    },
    removeLeft () {
      this.leftCharacterName = null
    },
    removeRight () {
      this.rightCharacterName = null
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/story-edit-view/conversation/bottomBlock.vue